module.exports = __webpack_public_path__ + "img/gafas-3.aac22f48.png";